import React from 'react';
import { Container, Button } from 'react-bootstrap';

// No 'react-router-dom' import needed in this version.

const NotFound = () => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '80vh',
                textAlign: 'center',
                padding: '20px',
            }}
        >
            <Container>
                <h1 style={{ fontSize: '7rem', fontWeight: 'bold', color: '#6c757d' }}>
                    404
                </h1>
                <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Page Not Found</h2>
                <p className="lead" style={{ color: '#6c757d' }}>
                    Oops! The page you are looking for does not exist or has been moved.
                </p>
                <hr style={{ margin: '2rem 0' }} />

                {/* This now uses a standard <a> tag instead of <Link> */}
                <a href="/">
                    <Button variant="primary" size="lg">
                        Go Back to Homepage
                    </Button>
                </a>
            </Container>
        </div>
    );
};

export default NotFound;